/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontRichiesteStatoTipoDomanda =
  (typeof GetFrontRichiesteStatoTipoDomanda)[keyof typeof GetFrontRichiesteStatoTipoDomanda];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontRichiesteStatoTipoDomanda = {
  BOZZA: 'BOZZA',
  PRONTA: 'PRONTA',
  COLLAUDO: 'COLLAUDO',
  PUBBLICATA: 'PUBBLICATA',
  APERTA: 'APERTA',
  IN_CORSO: 'IN_CORSO',
  SOSPESA: 'SOSPESA',
  ANNULLATA: 'ANNULLATA',
  CHIUSA: 'CHIUSA',
} as const;
